
// ----------------------------------------------------------------------------------------------------
// Explicitly require the dependencies that will be bundled into "vendorCore-bundle" by webpack and
// expose these globally. Bootstrap and jQuery are used on all pages, even server-side rendered pages.
// ----------------------------------------------------------------------------------------------------
import jquery from 'jquery';
import 'bootstrap';

window.$ = window.jQuery = jquery;
